export interface ConceptsRoot {
  result: ConceptsList
}

export enum ConceptsList {
  ALQ = 'Alquileres',
  APC = 'Aportes de capital',
  BRH = 'Bienes registrables habitualistas',
  BRN = 'Bienes registrables no habitualistas',
  CUO = 'Cuotas',
  EXP = 'Expensas',
  FAC = 'Facturas',
  HAB = 'Haberes',
  HON = 'Honorarios',
  OIN = 'Operaciones inmobiliarias',
  OIH = 'Operaciones inmobiliarias habitualista',
  PRE = 'Préstamos',
  ROP = 'Reintegros de obras sociales y prepagas',
  SEG = 'Seguros',
  SIS = 'Siniestros de seguros',
  SON = 'Suscripción obligaciones negociables',
  VAR = 'Varios'
}

// TODO: pedir enum de code errors

export enum LIMIT_ERRORS {
  ACCOUNT_WITHOUT_BALANCE = 'ACCOUNT_WITHOUT_BALANCE'
}

export interface CashoutResponse {
  status: string
  message: string
  uuid: string
  tax_type: string
  tax_value: string
  amount: string
  currency: string
  bank_name: string
  account_holder: string
}